// MicroSlide assay parameter definitions, mirroring MicroTip/DefaultParameters.js.
// These are the fields parsed by VitrosService::MicroSlideService for the
// /response, /calibrate and /predict endpoints.

export const fieldConfig = [
    // Basic
    { label: "Assay Model Type", name: "eAssayModelType", default: "0" }, // 6 = DM (Dual Wavelength)
    { label: "Increasing Rate", name: "bIncreasingRate", default: "1" },
    { label: "Dr To Dt Transform Flag", name: "bDrToDtTransformFlag", default: "0" },

    // Reportable range
    { label: "Reportable Range Low", name: "fReportableRangeLow", default: "2" },
    { label: "Reportable Range High", name: "fReportableRangeHigh", default: "120" },

    // Induction & subtraction
    { label: "SubDep Method Type", name: "eSubDepMethodType", default: "0" },
    { label: "Induction Time", name: "fInductionTime", default: "0" },
    { label: "SDT Limit", name: "fSDTLimit", default: "0" },
    { label: "Spike Deriv Tolerance", name: "fSpikeDerivTolerance", default: "0" },
    { label: "Inside Out Threshold", name: "fInsideOutThreshold", default: "0" },
    { label: "SubDep Time 1", name: "fSubDepTime1", default: "5.0" },
    { label: "SubDep Time 2", name: "fSubDepTime2", default: "10.0" },

    // Window & derivatives
    { label: "Min Points In Window", name: "sMinPointsInWindow", default: "0" },
    { label: "First Deriv Tolerance", name: "fFirstDerivTolerance", default: "0" },
    { label: "IR Algorithm", name: "eIRAlgorithm", default: "0" },
    { label: "Regression Method Type", name: "eRegressionMethodType", default: "0" },
    { label: "Window Modulator", name: "sWindowModulator", default: "0" },
    { label: "Window Length Max", name: "fWindowLengthMax", default: "0" },
    { label: "Window Length Min", name: "fWindowLengthMin", default: "0" },

    // Rate parameters
    { label: "Low Rate Long Window", name: "fLowRateLongWindowValue", default: "0" },
    { label: "High Rate Short Window", name: "fHighRateShortWindowValue", default: "0" },
    { label: "MWT Curve Dampening", name: "fMWTCurveDampeningConstant", default: "0" },
    { label: "MWT Spike Tolerance", name: "fMWTSpikeTolerance", default: "0" },

    // Spike limits
    { label: "CM Spike Limit B0", name: "fCMSpikeLimitB0", default: "0" },
    { label: "CM Spike Limit B1", name: "fCMSpikeLimitB1", default: "0" },
    { label: "CM Spike Limit B2", name: "fCMSpikeLimitB2", default: "0" },

    // Prediction
    { label: "Predict Time 1", name: "dPredictTime1", default: "330.27" },
    { label: "Predict Time 2", name: "dPredictTime2", default: "0" },
    { label: "AD To MV Conversion", name: "fADToMVConversionFactor", default: "0" },
    { label: "Time Template Size", name: "sTimeTemplateSize", default: "0" },
    { label: "Extrap Induction Limit", name: "fExtrapInductionLimit", default: "0" },
    { label: "Extrap Slope Limit", name: "fExtrapSlopeLimit", default: "0" },

    // Calibration / K-model
    { label: "K Exponent", name: "fKExponent", default: "2" },
    { label: "Logarithmic K Model", name: "bLogarithmicKModel", default: "0" },
    { label: "Monotonicity Flag", name: "eMonotonicityFlag", default: "1" },

    // Predict-only coefficients
    { label: "Cal Intercept A0", name: "fCalInterceptA0", default: "0" },
    { label: "Cal Slope A1", name: "fCalSlopeA1", default: "1" },
    { label: "Cal Curvature A2", name: "fCalCurvatureA2", default: "0" },
    { label: "Cal Blank Correction A3", name: "fCalBlankCorrectionFactorA3", default: "0" }
];

export const labelToNameMap = Object.fromEntries(
    fieldConfig.map(f => [f.label.toLowerCase(), f.name])
);

export const getLabel = (name) =>
    fieldConfig.find(f => f.name === name)?.label || name;

export const getCleanParameters = (params) => {
    const { TXBParse, ...clean } = params;
    return clean;
};

export const getInitialState = () => {
    const state = {};
    fieldConfig.forEach(f => (state[f.name] = f.default));
    return {
        ...state,
        TXBParse: ""
    };
};
